import { Pipe, PipeTransform } from '@angular/core';
import { StatusMapType } from '../../interfaces/status-map.enum';
import { SharedStatus } from '../../interfaces/status.enum';

const statusMap: Record<string, StatusMapType> = {
  [SharedStatus.Pending]: 'Awaiting approval (pending)',
  [SharedStatus.Submitted]: 'Awaiting approval (submitted)',
  [SharedStatus.Draft]: 'Awaiting approval (draft)',
  [SharedStatus.Approved]: 'Approved',
  [SharedStatus.Rejected]: 'Rejected',
  [SharedStatus.Reversed]: 'Reversed',
  [SharedStatus.Resubmitted]: 'Reversed',
  [SharedStatus.PartiallyApproved]: 'Partially approved',
  [SharedStatus.Paid]: 'Paid',
  [SharedStatus.Canceled]: 'Canceled',
};

@Pipe({
    name: 'sharedStatusMap',
    standalone: false
})
export class SharedStatusMapPipe<T> implements PipeTransform {
  transform(status: T): string {
    return statusMap[status];
  }
}
